import styled from 'styled-components';
import { getTextColor, themeGet } from '@magalu/stereo-ui-styles';
import { Box, Text, Heading } from '../../../atoms';
export const Container = styled(Box)`
  max-width: 1366px;
  margin: auto;
`;
export const Title = styled(Heading)`
  text-align: center;
  margin: 15px;
  font-weight: ${props => themeGet('fontWeights.bold')(props)};
  font-size: ${props => themeGet('fontSizes.0')(props)};
`;
export const ContentText = styled(Text)`
  padding: 5px 0;
  line-height: ${props => themeGet('lineHeights.input')(props)}em;
`;
export const ContentLink = styled(Text)`
  text-decoration: underline;
  color: ${props => getTextColor('base')(props)};
`;